import { apiService } from '../../../../../components/api/apiService';
import { logContextCopilot, normalizeMetadataJson, formatContextNarrative } from './modelContextSyntheticEngine';

const CONNECTION = 'backend_py';

export interface CopilotAnalyzeResponse {
    contextNarrative: string;
    analysisSummary: string;
    model: string;
    llmId: string;
}

function copilotErrorMessage(err: unknown): string {
    const axiosErr = err as {
        response?: { data?: { error?: { message?: string }; message?: string } };
        message?: string;
    };
    return (
        axiosErr.response?.data?.error?.message ||
        axiosErr.response?.data?.message ||
        axiosErr.message ||
        'Copilot request failed'
    );
}

export const copilotContextService = {
    async analyzeContext(payload: {
        metadataStructure: string;
        entityId?: string;
        modelName: string;
        followUp?: string;
        priorAnalysis?: string;
    }): Promise<CopilotAnalyzeResponse> {
        const metadataStructure = normalizeMetadataJson(payload.metadataStructure);
        logContextCopilot('app', 'copilot_analyze_request', {
            entityId: payload.entityId || 'all',
            metadataChars: metadataStructure.length,
            hasFollowUp: Boolean(payload.followUp?.trim()),
        });
        try {
            const data = (await apiService.post(
                '/api/v1/copilot/context/analyze',
                {
                    metadataStructure,
                    entityId: payload.entityId || 'all',
                    modelName: payload.modelName || '',
                    followUp: payload.followUp || undefined,
                    priorAnalysis: payload.priorAnalysis || undefined,
                },
                CONNECTION
            )) as Record<string, unknown>;
            const narrative = formatContextNarrative(
                data.contextNarrative ?? data.context_narrative ?? data.analysisSummary ?? data.analysis_summary ?? ''
            );
            const mapped: CopilotAnalyzeResponse = {
                contextNarrative: narrative,
                analysisSummary: narrative,
                model: String(data.model ?? ''),
                llmId: String(data.llmId ?? data.llm_id ?? ''),
            };
            logContextCopilot('app', 'copilot_analyze_ok', {
                llmId: mapped.llmId,
                narrativeChars: mapped.contextNarrative.length,
            });
            return mapped;
        } catch (err) {
            const message = copilotErrorMessage(err);
            logContextCopilot('error', 'copilot_analyze_failed', {
                message,
                metadataChars: metadataStructure.length,
            });
            throw new Error(message);
        }
    },
};
